// extracted by mini-css-extract-plugin
export var cardTitle = "_iq-1";
export var commentBubble = "_iq-e";
export var commentForm = "_iq-a";
export var commentInput = "_iq-b";
export var commentLabel = "_iq-d";
export var commentPrompt = "_iq-9";
export var csatCard = "_iq-0";
export var feedbackSection = "_iq-7";
export var starDisabled = "_iq-6";
export var starEmpty = "_iq-5";
export var starFilled = "_iq-4";
export var starWrapper = "_iq-3";
export var starsContainer = "_iq-2";
export var submittedComment = "_iq-c";
export var thankYouText = "_iq-8";